module.exports = __webpack_public_path__ + "fa5be1459fd70095728d8f6984a4872b.svg";